(function () {
  'use strict';

  const NB = window.NB = window.NB || {};
  const sessions = new WeakMap();

  function focusable(root) {
    return [...root.querySelectorAll(
      'a[href],button,input,select,textarea,[tabindex]'
    )].filter(node =>
      !node.disabled && node.tabIndex >= 0
      && !node.closest('[hidden],[inert]')
      && node.getClientRects().length
    );
  }

  NB.ui = {
    openDialog(dialog, initialFocus) {
      if (!(dialog instanceof HTMLDialogElement)) {
        throw new Error(window.CariamText("copy.text_293", 'このブラウザーでは確認画面を開けません。'));
      }
      if (dialog.open) return;
      const opener = document.activeElement;
      dialog.showModal();
      sessions.set(dialog, { opener });
      (initialFocus || focusable(dialog)[0])?.focus();
    },

    closeDialog(dialog) {
      if (!dialog?.open) return;
      dialog.close();
    },

    announce(message) {
      let region = document.getElementById('nb-live-status');
      if (!region) {
        region = document.createElement('p');
        region.id = 'nb-live-status';
        region.className = 'commerce-sr-only';
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        region.setAttribute('aria-atomic', 'true');
        document.body.append(region);
      }
      region.textContent = '';
      requestAnimationFrame(() => {
        region.textContent = message;
      });
    },

    async copy(text) {
      // No temporary textarea containing customer information is left behind.
      if (navigator.clipboard?.writeText && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }
      const field = document.createElement('textarea');
      const active = document.activeElement;
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.cssText =
        'position:fixed;left:-9999px;top:0;opacity:0';
      document.body.append(field);
      field.select();
      let copied = false;
      try {
        copied = document.execCommand('copy');
      } finally {
        field.remove();
        active?.focus({ preventScroll: true });
      }
      if (!copied) {
        throw new Error(window.CariamText("copy.text_294", 'コピーできませんでした。下の文字を選択してコピーしてください。'));
      }
    }
  };

  // Native showModal() supplies background inertness and Escape handling.
  // This additionally contains Tab and restores focus after native close.
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const dialogs = [...document.querySelectorAll('dialog[open]')];
    const dialog = dialogs[dialogs.length - 1];
    if (!dialog) return;
    const nodes = focusable(dialog);
    if (!nodes.length) {
      event.preventDefault();
      dialog.setAttribute('tabindex', '-1');
      dialog.focus();
      return;
    }
    const first = nodes[0], last = nodes[nodes.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !nodes.includes(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey
        && (active === last || !nodes.includes(active))) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('close', event => {
    const session = sessions.get(event.target);
    if (!session) return;
    sessions.delete(event.target);
    if (session.opener?.isConnected) {
      session.opener.focus({ preventScroll: true });
    }
  }, true);
})();
